// API Configuration

const BACKEND_URL =
  process.env.REACT_APP_BACKEND_URL ||
  "https://personal-port-vs5u.onrender.com";

export const API_BASE_URL = `${BACKEND_URL}/api`;

export const API_ENDPOINTS = {
  PERSONAL_INFO: "/personal-info",
  EDUCATION: "/education",
  RESEARCH_PROJECTS: "/research-projects",
  PUBLICATIONS: "/publications",
  EXPERIENCE: "/experience",
  CERTIFICATIONS: "/certifications",
  SKILLS: "/skills",
  ACHIEVEMENTS: "/achievements",
  TESTIMONIALS: "/testimonials",
  BLOG_POSTS: "/blog-posts",
};